const setLayer = () => {
  window.dataLayer = window.dataLayer || []
}
const currencyToNormalMethod = (value) => {
  if (!value) {
    return ''
  }
  return value.replace(/,/g, '')
}
const impressions = ({ teachers, canonical }) => teachers.map((item, index) => {
  const newItem = {
    name: item.full_name,
    id: item.id,
    price: Number(currencyToNormalMethod(item.teaching_price_formatted)),
    brand: item.stars,
    list: canonical,
    position: index + 1
  }
  return newItem
})
const setItemProductByIndex = ({ teacher, canonical, index }) => {
  return {
    name: teacher.full_name,
    id: teacher.id,
    price: Number(currencyToNormalMethod(teacher.teaching_price_formatted)),
    brand: teacher.stars,
    list: canonical,
    position: index + 1
  }
}
const setItemProduct = ({ teacher }) => {
  return {
    name: teacher.full_name,
    id: teacher.id,
    price: Number(currencyToNormalMethod(teacher.teaching_price_formatted)),
    brand: teacher.stars
  }
}
export default function ({}, inject) {
  const gtag = {
    push: (data) => {
      setLayer()
      window.dataLayer.push(data)
    },
    pushGtmCardClickEvent: ({ teacher, index, canonical }) => {
      setLayer()
      const item = setItemProductByIndex({ teacher, index })
      window.dataLayer.push({
        event: 'eec.productClick',
        ecommerce: {
          click: {
            actionField: {
              list: canonical
            },
            products: [item]
          }
        }
      })
    },
    pushProductDetail: ({ teacher }) => {
      const item = setItemProduct({ teacher })
      setLayer()
      window.dataLayer.push({
        event: 'eec.productDetail',
        ecommerce: {
          detail: {
            products: [item]
          }
        }
      })
    },
    impressionsPush: ({ teachers, canonical }) => {
      if (teachers.length > 0) {
        setLayer()
        window.dataLayer.push({
          event: 'eec.productImpression',
          ecommerce: {
            currencyCode: 'EUR',
            impressions: impressions({ teachers, canonical })
          }
        })
      }
    },
    impressionsSet: ({ teachers, canonical }) => {
      if (teachers.length > 0) {
        setLayer()
        window.dataLayer.push({
          event: 'eec.productImpression',
          ecommerce: {
            currencyCode: 'EUR',
            impressions: impressions({ teachers, canonical })
          }
        })
      }
    },
    TeacherVideoPackagePurchased: () => {
      setLayer()
      window.dataLayer.push({ event: 'TeacherVideoPackagePurchased' })
    },
    teacherListTeacherRequestSubmit: () => {
      setLayer()
      window.dataLayer.push({ event: 'teacherListTeacherRequestSubmit' })
    },
    teacherProfileTeacherRequestSubmit: () => {
      setLayer()
      window.dataLayer.push({ event: 'teacherProfileTeacherRequestSubmit' })
    },
    teacherListSuggestTeacherSubmit: () => {
      setLayer()
      window.dataLayer.push({ event: 'teacherListSuggestTeacherSubmit' })
    },
    startTeachingSubmitted: () => {
      setLayer()
      window.dataLayer.push({ event: 'start_teaching_submitted' })
    },
    pushGtmCheckout: ({ teacher }) => {
      setLayer()
      const item = setItemProduct({ teacher })
      window.dataLayer.push({
        event: 'eec.checkout',
        ecommerce: {
          checkout: {
            actionField: { step: 1 },
            products: [item]
          }
        }
      })
    }
  }
  inject('gtag', gtag)
}
